import { RESTError } from "../core/RESTError";

/**
 * An error that occurs because of system conflicts
 */
export class SystemConflictError extends RESTError {}
